<template>
  <div class="seller-manage-container">
    <h2 class="page-title">商户管理</h2>
    
    <div class="action-bar">
      <button class="btn btn-primary" @click="showAddForm = true">新增商户</button>
    </div>
    
    <div v-if="error" class="alert alert-danger">{{ error }}</div>
    <div v-if="success" class="alert alert-success">{{ success }}</div>
    
    <table class="data-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>用户名</th>
          <th>店铺名称</th>
          <th>联系人</th>
          <th>联系电话</th>
          <th>状态</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="seller in sellers" :key="seller.id">
          <td>{{ seller.id }}</td>
          <td>{{ seller.username }}</td>
          <td>{{ seller.shopName }}</td>
          <td>{{ seller.contactName }}</td>
          <td>{{ seller.contactPhone }}</td>
          <td>
            <span class="status-badge" :class="seller.active ? 'active' : 'inactive'">
              {{ seller.active ? '活跃' : '禁用' }}
            </span>
          </td>
          <td class="action-buttons">
            <button class="btn btn-sm btn-outline" @click="editSeller(seller)">编辑</button>
            <button class="btn btn-sm btn-danger" @click="deleteSeller(seller.id)">删除</button>
          </td>
        </tr>
      </tbody>
    </table>
    
    <!-- 新增/编辑商户表单 -->
    <div v-if="showAddForm || currentSeller" class="modal-overlay" @click="closeForm">
      <div class="modal-content" @click.stop>
        <h3>{{ currentSeller ? '编辑商户' : '新增商户' }}</h3>
        
        <form @submit.prevent="saveSeller">
          <div class="form-group">
            <label>用户名</label>
            <input 
              type="text" 
              v-model="sellerForm.username" 
              class="form-control" 
              :disabled="currentSeller"
              required
            >
          </div>
          
          <div class="form-group">
            <label>密码</label>
            <input 
              type="password" 
              v-model="sellerForm.password" 
              class="form-control" 
              :required="!currentSeller"
            >
          </div>
          
          <div class="form-group">
            <label>店铺名称</label>
            <input 
              type="text" 
              v-model="sellerForm.shopName" 
              class="form-control" 
              required
            >
          </div>
          
          <div class="form-group">
            <label>联系人</label>
            <input 
              type="text" 
              v-model="sellerForm.contactName" 
              class="form-control" 
              required
            >
          </div>
          
          <div class="form-group">
            <label>联系电话</label>
            <input 
              type="text" 
              v-model="sellerForm.contactPhone" 
              class="form-control" 
              required
            >
          </div>
          
          <div class="form-group">
            <label>状态</label>
            <select v-model="sellerForm.active" class="form-control">
              <option :value="true">活跃</option>
              <option :value="false">禁用</option>
            </select>
          </div>
          
          <div class="form-actions">
            <button type="button" class="btn btn-outline" @click="closeForm">取消</button>
            <button type="submit" class="btn btn-primary">保存</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SellerManage',
  data() {
    return {
      sellers: [],
      error: '',
      success: '',
      showAddForm: false,
      currentSeller: null,
      sellerForm: {
        username: '',
        password: '',
        shopName: '',
        contactName: '',
        contactPhone: '',
        active: true
      }
    }
  },
  mounted() {
    this.loadSellers()
  },
  methods: {
    async loadSellers() {
      try {
        const response = await fetch('/api/seller', {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('sellerToken')}`
          }
        })
        
        if (!response.ok) {
          throw new Error('获取商户列表失败')
        }
        
        const data = await response.json()
        this.sellers = data
      } catch (error) {
        this.error = error.message
      }
    },
    
    editSeller(seller) {
      this.currentSeller = seller
      this.sellerForm = {
        username: seller.username,
        password: '',
        shopName: seller.shopName,
        contactName: seller.contactName,
        contactPhone: seller.contactPhone,
        active: seller.active
      }
    },
    
    closeForm() {
      this.showAddForm = false
      this.currentSeller = null
      this.sellerForm = {
        username: '',
        password: '',
        shopName: '',
        contactName: '',
        contactPhone: '',
        active: true
      }
      this.error = ''
      this.success = ''
    },
    
    async saveSeller() {
      try {
        let response
        const url = this.currentSeller 
          ? `/api/seller/${this.currentSeller.id}`
          : '/api/seller/register'
        
        const method = this.currentSeller ? 'PUT' : 'POST'
        
        const body = JSON.stringify(this.sellerForm)
        
        response = await fetch(url, {
          method,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('sellerToken')}`
          },
          body
        })
        
        const data = await response.json()
        
        if (!data.success && !this.currentSeller) {
          throw new Error(data.message || '操作失败')
        }
        
        this.success = this.currentSeller ? '商户更新成功' : '商户创建成功'
        this.closeForm()
        this.loadSellers()
      } catch (error) {
        this.error = error.message
      }
    },
    
    async deleteSeller(sellerId) {
      if (!confirm('确定要删除这个商户吗？')) {
        return
      }
      
      try {
        const response = await fetch(`/api/seller/${sellerId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('sellerToken')}`
          }
        })
        
        if (!response.ok) {
          throw new Error('删除失败')
        }
        
        this.success = '商户删除成功'
        this.loadSellers()
      } catch (error) {
        this.error = error.message
      }
    }
  }
}
</script>

<style scoped>
.seller-manage-container {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.page-title {
  color: #333;
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: 600;
}

.action-bar {
  margin-bottom: 20px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  border-radius: 8px;
  overflow: hidden;
}

.data-table th,
.data-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e5e5e5;
}

.data-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}

.data-table tr:hover {
  background-color: #f9f9f9;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.active {
  background-color: #e6f7ee;
  color: #13c2c2;
}

.status-badge.inactive {
  background-color: #fff2e8;
  color: #fa8c16;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.btn-sm {
  padding: 4px 12px;
  font-size: 12px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.modal-content h3 {
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
}

.form-control:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.alert {
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.alert-danger {
  background-color: #fff1f0;
  border: 1px solid #ffccc7;
  color: #f5222d;
}

.alert-success {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
  color: #52c41a;
}
</style>